export default {
    resend_invite_title: "Reenviar invitación",
    resend_invite_message: "¿Desea reenviar la invitación?",
    resend_invite_success_message: "La invitación ha sido reenviada",
    resend_invite_error_message: "No se puede reenviar la invitación debido a un error",
    resend_invite_new_password: "Nueva contraseña",
};